"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatAttendanceXL = exports.AttendanceXL = exports.FormatEventXL = exports.EventXL = exports.formatPhone = void 0;
const ramda_1 = require("ramda");
const Maybe_1 = require("../../lib/Maybe");
const Util_1 = require("../../lib/Util");
const types_1 = require("../../typings/types");
const gradeOrder_1 = require("../../consts/gradeOrder");
const EventStatusDisplay = {
    [types_1.EventStatus.DRAFT]: 'Draft',
    [types_1.EventStatus.TENTATIVE]: 'Tentative',
    [types_1.EventStatus.CONFIRMED]: 'Confirmed',
    [types_1.EventStatus.COMPLETE]: 'Complete',
    [types_1.EventStatus.CANCELLED]: 'Cancelled',
    [types_1.EventStatus.INFORMATIONONLY]: 'Information Only',
};
const DisplayAttendanceStatus = {
    [types_1.AttendanceStatus.COMMITTEDATTENDED]: 'Committed/Attended',
    [types_1.AttendanceStatus.NOSHOW]: 'No Show',
    [types_1.AttendanceStatus.RESCINDEDCOMMITMENTTOATTEND]: 'Rescinded Commitment',
    [types_1.AttendanceStatus.NOTPLANNINGTOATTEND]: 'Not Planning to Attend',
};
function formatPhone(phone) {
    phone.trimLeft().trimRight();
    if (phone) {
        const result = phone.match(/\d+/g);
        if (result) {
            phone = result.join('');
            return ('(' +
                phone.substring(0, 3) +
                ')' +
                phone.substring(3, 6) +
                '-' +
                phone.substring(6, 10));
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
}
exports.formatPhone = formatPhone;
const GetBestPhones = (inMember) => {
    let numbersData = '';
    if (inMember.contact.CELLPHONE.PRIMARY) {
        numbersData += 'CP ' + formatPhone(inMember.contact.CELLPHONE.PRIMARY) + '\n';
    }
    if (inMember.contact.CELLPHONE.SECONDARY) {
        numbersData += 'CS ' + formatPhone(inMember.contact.CELLPHONE.SECONDARY) + '\n';
    }
    if (inMember.contact.CELLPHONE.EMERGENCY) {
        numbersData += 'CE ' + formatPhone(inMember.contact.CELLPHONE.EMERGENCY) + '\n';
    }
    if (inMember.contact.CADETPARENTPHONE.PRIMARY) {
        numbersData += 'PP ' + formatPhone(inMember.contact.CADETPARENTPHONE.PRIMARY) + '\n';
    }
    if (inMember.contact.CADETPARENTPHONE.SECONDARY) {
        numbersData += 'PS ' + formatPhone(inMember.contact.CADETPARENTPHONE.SECONDARY) + '\n';
    }
    if (inMember.contact.CADETPARENTPHONE.EMERGENCY) {
        numbersData += 'PE ' + formatPhone(inMember.contact.CADETPARENTPHONE.EMERGENCY) + '\n';
    }
    if (inMember.contact.HOMEPHONE.PRIMARY) {
        numbersData += 'HP ' + formatPhone(inMember.contact.HOMEPHONE.PRIMARY) + '\n';
    }
    if (inMember.contact.HOMEPHONE.EMERGENCY) {
        numbersData += 'HE ' + formatPhone(inMember.contact.HOMEPHONE.EMERGENCY) + '\n';
    }
    if (numbersData.length > 2) {
        numbersData = numbersData.substring(0, numbersData.length - 1);
        return numbersData;
    }
    else {
        return '';
    }
};
const GetRank = (inMember) => inMember.memberRank;
const GetName = (inMember) => inMember.nameLast + ', ' + inMember.nameFirst;
const GetGradeOrder = (inMember) => { var _a, _b; return (_b = (_a = gradeOrder_1.GradeOrderMap.find(member => member.Grade === inMember.memberRank)) === null || _a === void 0 ? void 0 : _a.GradeOrder) !== null && _b !== void 0 ? _b : 0; };
const GetBestEmails = (inMember) => {
    let numbersData = '';
    if (inMember.contact.EMAIL.PRIMARY) {
        numbersData += inMember.contact.EMAIL.PRIMARY + ', ';
    }
    if (inMember.contact.EMAIL.SECONDARY) {
        numbersData += inMember.contact.EMAIL.SECONDARY + ', ';
    }
    if (inMember.contact.EMAIL.EMERGENCY) {
        numbersData += inMember.contact.EMAIL.EMERGENCY + ', ';
    }
    if (inMember.contact.CADETPARENTEMAIL.PRIMARY) {
        numbersData += inMember.contact.CADETPARENTEMAIL.PRIMARY + ', ';
    }
    if (inMember.contact.CADETPARENTEMAIL.SECONDARY) {
        numbersData += inMember.contact.CADETPARENTEMAIL.SECONDARY + ', ';
    }
    if (inMember.contact.CADETPARENTEMAIL.EMERGENCY) {
        numbersData += inMember.contact.CADETPARENTEMAIL.EMERGENCY + ', ';
    }
    if (numbersData.length > 2) {
        numbersData = numbersData.substring(0, numbersData.length - 1);
        return numbersData;
    }
    else {
        return '';
    }
};
const CustomAttendanceFieldTypeDisplay = {
    [types_1.CustomAttendanceFieldEntryType.TEXT]: 'Text',
    [types_1.CustomAttendanceFieldEntryType.NUMBER]: 'Number',
    [types_1.CustomAttendanceFieldEntryType.DATE]: 'Date',
    [types_1.CustomAttendanceFieldEntryType.CHECKBOX]: 'Checkbox',
    [types_1.CustomAttendanceFieldEntryType.FILE]: 'File',
    [types_1.CustomAttendanceFieldEntryType.QUAL]: 'OPS Qual',
};
const EventXL = (event) => {
    let row = [
        'Event Manager Event Information and Sign-up/Attendance Roster',
    ];
    const retVal = [];
    retVal.push(row);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    row = ['Account-Event', '', 'Start Date/Time', 'End Date/Time', 'Location'];
    retVal.push(row);
    row = [
        `${event.accountID}-${event.id}`,
        '',
        event.startDateTime,
        event.endDateTime,
        event.location,
    ];
    retVal.push(row);
    retVal.push([]);
    row = ['Status', 'Event Name'];
    retVal.push(row);
    row = [EventStatusDisplay[event.status], event.name];
    retVal.push(row);
    retVal.push([]);
    row = ['Comments'];
    retVal.push(row);
    row = [event.comments];
    retVal.push(row);
    if (event.customAttendanceFields.length > 0) {
        const numPadding = 8;
        for (let l = 0; l < numPadding; l++) {
            retVal.push([]);
        }
        retVal.push(['Custom Attendance Fields', '', '', '', '', 'Can Member']);
        row = ['Field Name', '', 'Field Type', 'Prefill Value', '', 'See?', 'Edit?'];
        retVal.push(row);
        retVal.push([]);
        let fieldPreFill;
        for (const customField of event.customAttendanceFields) {
            if (customField.type !== types_1.CustomAttendanceFieldEntryType.FILE &&
                customField.type !== types_1.CustomAttendanceFieldEntryType.QUAL) {
                fieldPreFill =
                    typeof customField.preFill === 'boolean'
                        ? customField.preFill
                            ? 'Y'
                            : 'N'
                        : customField.preFill;
            }
            else if (customField.type !== types_1.CustomAttendanceFieldEntryType.QUAL) {
                fieldPreFill = 'Qual Data';
            }
            else {
                fieldPreFill = 'N/A';
            }
            row = [
                customField.title,
                '',
                CustomAttendanceFieldTypeDisplay[customField.type],
                fieldPreFill,
                '',
                customField.displayToMember ? 'Y' : 'N',
                customField.allowMemberToModify ? 'Y' : 'N',
            ];
            retVal.push(row);
        }
    }
    return retVal;
};
exports.EventXL = EventXL;
const FormatEventXL = (evt, sheet, hostname, customAttendanceFieldValues) => {
    const dateFormat = 'mm/dd/yyyy hh:mm';
    const dateWidth = dateFormat.length;
    const aid = evt.split('-')[0];
    const eid = evt.split('-')[1];
    sheet['!merges'] = [
        { s: { c: 0, r: 0 }, e: { c: 4, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
        { s: { c: 1, r: 7 }, e: { c: 4, r: 7 } },
        { s: { c: 0, r: 10 }, e: { c: 4, r: 15 } },
    ];
    sheet.A1.s = [
        { font: { bold: true } },
        { alignment: { horizontal: 'center' } },
    ];
    sheet.A2.t = 't';
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    sheet.A5.l = { Target: `https://${aid}.${hostname}/eventviewer/${eid}` };
    sheet.C5.t = 'd';
    sheet.C5.z = dateFormat;
    sheet.D5.t = 'd';
    sheet.D5.z = dateFormat;
    sheet.A11.t = 't';
    sheet['!cols'] = [
        { width: 12 },
        { width: 12 },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 25 },
    ];
    sheet['!rows'] = [{ hpx: 19 }, {}, {}, { hpx: 17 }, { hpx: 14 }, {}, { hpx: 17 }, { hpx: 14 }];
    const startRow = 23;
    for (let j = 0; j < customAttendanceFieldValues.length; j++) {
        const type = customAttendanceFieldValues[j].type;
        if (type === types_1.CustomAttendanceFieldEntryType.DATE) {
            sheet[`D${startRow + j}`].t = 'd';
            sheet[`D${startRow + j}`].z = dateFormat;
        }
    }
    return sheet;
};
exports.FormatEventXL = FormatEventXL;
const AttendanceXL = (event, attendance) => {
    let widths = [];
    let row = [
        'Timestamp',
        'CAPID',
        'Grade',
        'Grade Order',
        'Name',
        'Arrival Time',
        'Departure Time',
        'Status',
        'CAP Transport',
        'Email(s)',
        'Phone(s)',
        'Comments',
        'Unit Name',
        'Commander Name',
        'Unit Contacts',
    ];
    const retVal = [];
    for (const fieldName of event.customAttendanceFields) {
        row.push(fieldName.title);
    }
    widths = [...row.map(item => item.toString().length)];
    retVal.push(row);
    const orEmptyString = Maybe_1.Maybe.orSome('');
    const orZero = Maybe_1.Maybe.orSome(0);
    const getCommanderName = ramda_1.pipe(Maybe_1.Maybe.flatMap(Util_1.get('commanderName')), orEmptyString);
    const getUnitName = ramda_1.pipe(Maybe_1.Maybe.flatMap(Util_1.get('orgName')), orEmptyString);
    const getUnitWebsite = ramda_1.pipe(Maybe_1.Maybe.map(({ contacts }) => contacts
        .filter(({ type }) => type === 'URL')
        .map(Util_1.get('contact'))
        .join('\n')), orEmptyString);
    const getUnitEmails = ramda_1.pipe(Maybe_1.Maybe.map(({ contacts }) => contacts
        .filter(({ type }) => type === 'EMAIL')
        .map(Util_1.get('contact'))
        .join('\n')), orEmptyString);
    for (const attendee of attendance) {
        row = [
            attendee.record.timestamp,
            `${attendee.record.memberID.id} `,
            orEmptyString(Maybe_1.Maybe.map(GetRank)(attendee.member)),
            orZero(Maybe_1.Maybe.map(GetGradeOrder)(attendee.member)),
            orEmptyString(Maybe_1.Maybe.map(GetName)(attendee.member)),
            attendee.record.shiftTime.arrivalTime,
            attendee.record.shiftTime.departureTime,
            DisplayAttendanceStatus[attendee.record.status],
            attendee.record.planToUseCAPTransportation ? 'Y' : 'N',
            orEmptyString(Maybe_1.Maybe.map(GetBestEmails)(attendee.member)),
            orEmptyString(Maybe_1.Maybe.map(GetBestPhones)(attendee.member)),
            attendee.record.comments,
            getUnitName(attendee.orgInformation),
            getCommanderName(attendee.orgInformation),
            getUnitWebsite(attendee.orgInformation),
            getUnitEmails(attendee.orgInformation),
        ];
        for (const fieldVal of attendee.record.customAttendanceFieldValues) {
            row.push(typeof fieldVal.value === 'boolean'
                ? fieldVal.value
                    ? 'Y'
                    : 'N'
                : Array.isArray(fieldVal.value)
                    ? `${fieldVal.value.length} files`
                    : fieldVal.value);
        }
        widths = widths.map((width, index) => {
            var _a;
            return Math.max(width, ((_a = row[index]) !== null && _a !== void 0 ? _a : '')
                .toString()
                .split('\n')
                .map(Util_1.get('length'))
                .reduce((prev, curr) => Math.max(prev, curr), 0));
        });
        retVal.push(row);
    }
    return [retVal, widths.map(width => width + 3)];
};
exports.AttendanceXL = AttendanceXL;
const FormatAttendanceXL = (sheet, columnMaxWidths, customAttendanceFieldValues, encodeCell, numRows) => {
    var _a, _b, _c, _d;
    const dateFormat = 'yyyy-mm-dd hh:mm';
    const numStaticColumns = 15;
    let rowCount = 0;
    let emails = '';
    let phones = '';
    const rowHeight = 11;
    sheet['!rows'] = [{ hpt: rowHeight }];
    let j = 2;
    while (j <= numRows) {
        rowCount = 0;
        sheet[`A${j}`].t = 'd';
        sheet[`A${j}`].z = dateFormat;
        sheet[`F${j}`].t = 'd';
        sheet[`F${j}`].z = dateFormat;
        sheet[`G${j}`].t = 'd';
        sheet[`G${j}`].z = dateFormat;
        for (let i = 0; i < customAttendanceFieldValues.length; i++) {
            const type = customAttendanceFieldValues[i].type;
            if (type === types_1.CustomAttendanceFieldEntryType.DATE) {
                const cell = sheet[encodeCell({ c: i + (numStaticColumns + 1), r: j - 1 })];
                cell.t = 'd';
                cell.z = dateFormat;
            }
        }
        emails = (_b = (_a = sheet[`H${j}`]) === null || _a === void 0 ? void 0 : _a.v) !== null && _b !== void 0 ? _b : '';
        phones = (_d = (_c = sheet[`I${j}`]) === null || _c === void 0 ? void 0 : _c.v) !== null && _d !== void 0 ? _d : '';
        rowCount = Math.max(emails.split('\n').length, phones.split('\n').length);
        sheet['!rows'].push({ hpt: rowHeight + rowCount * rowHeight });
        j += 1;
    }
    sheet['!cols'] = columnMaxWidths.map(wch => ({ wch }));
    sheet.A1.t = 't';
    sheet.A1.v = 'Timestamp';
    return sheet;
};
exports.FormatAttendanceXL = FormatAttendanceXL;
//# sourceMappingURL=AttendanceXlsx.js.map